<template>
    <div class="message-wrapper" ref="scrollbox">
        <ul class="message-list" v-if="msgList.length && ajaxDone" ref="scrollList">
            <li class="message-list-item" v-for="(msg,index) in msgList" @click="goDetail2(msg)">
                <img class="head-img" :src="msg.HeadImage || '/static/images/default.png'" @error="$imgErr">
                <div class="reply">
                    <div class='replyer-title'>
                        <div class='replyer-name'>{{msg.ReplyName}}</div>
                        <div  class="knowledge-expert" v-if="msg.Identity == 1">
                            <img src="/static/images/knowledge_expert.png" alt="">
                        </div>
                    </div>
                    <div v-if="!msg.IsDel">
                        <div class="reply-content" v-if="msg.Comment"><span v-if="msg.ReplyToADAccount">回复了我：</span>{{ msg.Comment }}</div>
                        <div class="reply-img" v-if="msg.AttachList && msg.AttachList.length">
                            <picture class="picture" v-for="(imgs,i) in msg.AttachList"  @click.stop="showImg(i,msg.AttachList)">
                                <img class="source-img" :src="imgs"  @error="$imgErr">
                            </picture>
                        </div>
                    </div>
                    <div class="deleted-box" v-else>
                         <span class='left-cane'></span>
                            <span class='delete-tip'>评论已删除</span>
                            <span class='right-cane'></span>
                    </div>
                </div>
            </li>
            <span class="view-history-msg" @click="showHistoryMsg" v-if="hasUnread">展开消息列表</span>
            <loading-more></loading-more>
        </ul>
        <div class="no-message" v-else-if="ajaxDone">
            暂未收到回复
        </div>

        <photo-package v-if="sourceList && sourceList.length" :list="sourceList" :options="options" selector=".source-img" @on-close="closeHandler" ref="sourcePreview">
        </photo-package>

        <!-- 水印组件 -->
        <water-mark ref="watermark"></water-mark>
    </div>
</template>
<script>

import waterMark from '@/components/waterMark'
import {  COMMENTS } from '../../api'
import loadingMore from '@/components/loadingMore'
import store from '@/store/index'
import PhotoPackage from 'photoswipe-package'
export default {
    name:'message',
    components:{loadingMore,PhotoPackage,waterMark},
    data(){
        return{
            ajaxDone:false,
            prevAjaxEnd:true,
            scrollTop:0,
            hasUnread:true, //是否有未读消息
            msgTotal:0, //消息总数
            pageIndex:1,
            pageSize:10,
            msgList:[],

            // 图片预览组件
            sourceList:null,
            options: {
                loop: false,
                zoomEl: true,
                fullscreenEl: false,
                tapToClose: true
            },

        }
    },
    mounted() {
        this.$refs.scrollbox.addEventListener('scroll', this.scrollHandler, false)
        this.initData();
    },
    methods: {
        initData(){
            this.ajaxDone = false
            this.prevAjaxEnd = true
            this.msgTotal = 0
            this.scrollTop = 0
            this.pageIndex = 1
            this.msgList = [];
            COMMENTS.GetMsgList({
                PageIndex:this.pageIndex,
                PageSize:this.pageSize
            }).then(res=>{
                if(res.Data&&res.Data.List) {
                    this.msgTotal = Math.ceil(res.Data.TotalCount / this.pageSize);
                    this.msgList = res.Data.List
                    this.hasUnread = res.Data.IsHasUnRead
                }
                this.ajaxDone = true;
            })
        },
        showHistoryMsg(){
            this.hasUnread = false
            this.$refs.scrollbox.addEventListener('scroll', this.scrollHandler, false)
            this.initData();
        },
        scrollHandler(){
            if (this.hasUnread) return
            let scrollTop = this.$refs.scrollbox.scrollTop
            let visible_h = this.$refs.scrollbox.clientHeight - document.querySelector('#navbar-fixed').clientHeight
            let scrollBox_h = this.$refs.scrollList.clientHeight
            if (scrollTop + visible_h >= scrollBox_h) {
                this.loadMoreMsg()
            }
        },
        loadMoreMsg(){
            if (!this.prevAjaxEnd) return
            if (this.pageIndex >= this.msgTotal) return
            this.prevAjaxEnd = false
            store.commit('SET_LOADING_POSITION','bottom')
            COMMENTS.GetMsgList({
                PageIndex:++this.pageIndex,
                PageSize:this.pageSize
            }).then(res=>{
                if(res.Data&&res.Data.List) {
                    this.msgList = this.msgList.concat(res.Data.List)
                    this.prevAjaxEnd = true
                    store.commit('SET_LOADING_POSITION','middle')
                }
            }).catch(()=>{
                this.prevAjaxEnd = true
                store.commit('SET_LOADING_POSITION','middle')
            })
        },
        goDetail2(msg) {
            if (msg.KBType === 1) {  // 知识点
                if (msg.IsMain) {  // 主评论
                    this.$router.push({
                        name: 'replyList',
                        params: {
                            commentId: msg.MainCommentId,  // 主评论Id
                            uuid: msg.KBInfoId  // 知识点的Id
                        }
                    })
                    
                } else {  // 二级评论
                    this.$router.push({
                        name: 'replyList',
                        params: {
                            commentId: msg.MainCommentId,  // 主评论Id
                            uuid: msg.KBInfoId,  // 知识点的Id
                            matchCommentId: msg.Id  // 【回复内容】的评论Id
                        }
                    })
                }
            } else {  // FAQ
                console.log('FAQ跳转......')
                if (msg.IsMain) {  // 主评论
                    this.$router.push({
                        name: 'replyList',
                        params: {
                            commentId: msg.MainCommentId,  // 主评论Id
                            uuid: msg.KBInfoId  // 知识点的Id
                        }
                    })
                    
                } else {  // 二级评论
                    this.$router.push({
                        name: 'replyList',
                        params: {
                            commentId: msg.MainCommentId,  // 主评论Id
                            uuid: msg.KBInfoId,  // 知识点的Id
                            matchCommentId: msg.Id  // 【回复内容】的评论Id
                        }
                    })
                }
            }
        },
        goDetail(msg){
            if(msg.KBType == 1){  //如果评论的是知识点，跳转知识点
                // 判断是否是一级评论
                if(msg.Id == msg.MainCommentId) {  //是一级评论,跳转到知识详情页面
                // this.$router.push({ name: 'knowledge', params: { uuid: msg.KBInfoId, commentId:msg.MainCommentId, subCommentId: msg.Id || msg.CommentId } })
                this.$router.push({ name: 'knowledge', params: { uuid: msg.KBInfoId, commentId: msg.MainCommentId } })
                }else{  //二级评论
                    this.$router.push({ name: 'replyList', params: {commentId:msg.MainCommentId, uuid: msg.KBInfoId, subCommentId: msg.Id || msg.CommentId} })
                }
            }else if(msg.KBType == 2){  //如果评论的是faq,跳转faq
                // 判断是否是一级评论
                if(msg.Id == msg.MainCommentId) {  //是一级评论,跳转到知识详情页面
                    this.$router.push({ name: 'faq', params: { uuid: msg.KBInfoId , commentId:msg.MainCommentId } })
                }else{  //二级评论
                    this.$router.push({ name: 'replyList', params: {commentId:msg.MainCommentId , uuid: msg.KBInfoId, subCommentId: msg.Id || msg.CommentId} })
                }
            }
        },
        showImg(index,sourceList) {
            // 图片预览
            let imgList = sourceList.map((e)=>{
                return {
                    // transfer key named `FileUrl` to `src`
                    src: e,
                    FileName: e,
                    FileType: 'jpg'
                }
            })
            this.sourceList = imgList
            this.$nextTick(()=>{
                this.$refs.sourcePreview.show(index)
                this.$refs.watermark && this.$refs.watermark.initWaterMark(true)
            })
        },
        closeHandler(){
            this.sourceList = [];
        }
    },
    watch: {
        "$route"(to,from){
            if(to.name !== 'message') return;
            this.$refs.scrollbox.scrollTop = this.scrollTop
            if(from.name === 'knowledge' || from.name === 'faq' || from.name === 'replyList') return
            this.initData()
        }
    },
    beforeRouteLeave (to, from, next) {
        this.scrollTop = this.$refs.scrollbox.scrollTop
        next()
    }
}
</script>
<style lang="scss" type="text/scss" scoped>
    .message-wrapper{
        height: 100%;
        overflow: scroll;
        box-sizing: border-box;
        padding-bottom:j(98);
        .message-list{
            padding: 0 j(50);
        }
        .message-list-item{
            border-bottom: 1px solid #F0F1F2;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding: j(40) 0;
            list-style: none;
        }
        .head-img{
            height: j(80);
            width: j(80);
            border-radius: 50%;
        }
        .reply{
            width: j(550);
            display: flex;
            flex-direction: column;
        }
        .replyer-title{
            font-size: j(28);
            font-weight: 700;
            color: #363C54;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .replyer-name{
                padding-right: j(20);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
            }
            .knowledge-expert{
                height: 100%;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                img{
                    width: j(84);
                    height: j(30);
                }
            }
        }
        .reply-content{
            margin-top: j(10);
            font-size: j(32);
            font-weight: 300;
            color: #363C54;
            word-break: break-word;
            span{
                color: #9B9DA9;
                white-space: nowrap;
            }
        }
        .reply-img{
            display: flex;
            margin-top: j(10);

            .picture {
                height: j(100);
                width: j(100);
                background-image: url('/static/images/before_load.png');
                background-repeat: no-repeat;
                background-size: contain;

            }
            .picture+.picture{
                margin-left: j(20);
            }
            img{
                height: 100%;
                width: 100%;
                border-radius: 4px;
                border:1px solid rgba(240,241,242,1);
                pointer-events: none;
            }
            img+img{
                margin-left: j(20);
            }
        }

        .reply-content + .reply-img {
            margin-top: j(40);
        }

        .deleted-box{
            height:j(42);
            font-size:j(32);
            color:#9B9DA9;
            position: relative;
            margin-top:j(10);

            .left-cane{
                width:j(6);
                height:j(14);
                // border:1px solid red;
                display: inline-block;
                border-top:1px solid #9B9DA9;
                border-left:1px solid #9B9DA9;
                transform: scale(1.5);
                position: absolute;
                top:j(14);
            }
            .delete-tip{
                height:j(42);
                font-size:j(32);
                color:#9B9DA9;
                display: inline-block;
                margin:0 j(5) 0 j(10);
            }
            .right-cane{
                width:j(6);
                height:j(14);
                // border:1px solid red;
                display: inline-block;
                border-right:1px solid #9B9DA9;
                border-bottom:1px solid #9B9DA9;
                transform: scale(1.5);
                position: absolute;
                top:j(20);
            }

        }

        .view-history-msg{
            display: block;
            width: j(238);
            padding: j(10) 0;
            box-sizing: border-box;
            text-align: center;
            background:rgba(240,252,252,1);
            border-radius:j(28);
            color: #00bebe;
            font-size: j(28);
            margin: j(50) auto;
        }

        .no-message{
            padding-top: j(300);
            box-sizing: border-box;
            position: absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-35%);
            width: j(750);
            height: j(700);
            background: url('/static/images/empty/no-message.png') no-repeat;
            background-size: contain;
            background-position: center;
            text-align: center;
            font-size:j(32);
            font-weight:400;
            color:rgba(155,157,169,1);
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/message/message.vue